import React from "react";
import { Box, Typography } from "@mui/material";
import { androidLightTokens } from "../styles/androidJigsawTokens";

const LEVELS = [
    { size: 6, name: "Easy", pieces: 36, emoji: "🌱", bg: "#43A047" },
    { size: 9, name: "Medium", pieces: 81, emoji: "⚡", bg: "#FB8C00" },
    { size: 12, name: "Hard", pieces: 144, emoji: "🔥", bg: "#E53935" },
    { size: 16, name: "Pro", pieces: 256, emoji: "🏆", bg: "#1E88E5" },
    { size: 24, name: "Elite", pieces: 576, emoji: "👑", bg: "#8E24AA" },
    { size: 32, name: "Insane", pieces: 1024, emoji: "💀", bg: "#6A1B9A" },
];

/**
 * CHOOSE LEVEL sheet shown after Play on a gallery puzzle.
 */
export default function AppleChooseLevelDialog() {
    const rows = [LEVELS.slice(0, 3), LEVELS.slice(3, 6)];

    return (
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                zIndex: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2.5,
                bgcolor: "rgba(0,0,0,0.55)",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 400,
                    borderRadius: "16px",
                    border: `1px solid ${androidLightTokens.cardBorder}`,
                    bgcolor: androidLightTokens.cardBg,
                    px: 1.5,
                    pt: 1.75,
                    pb: 1,
                    boxSizing: "border-box",
                }}
            >
                <Typography
                    component="h2"
                    sx={{
                        m: 0,
                        mb: 0.25,
                        textAlign: "center",
                        fontSize: 13,
                        fontWeight: 800,
                        letterSpacing: "1.2px",
                        color: androidLightTokens.shellTextMuted,
                    }}
                >
                    CHOOSE LEVEL
                </Typography>
                <Typography
                    component="p"
                    sx={{
                        m: 0,
                        mb: 1.25,
                        textAlign: "center",
                        fontSize: 12,
                        fontWeight: 600,
                        color: androidLightTokens.shellTextMuted,
                    }}
                >
                    Free puzzle
                </Typography>
                {rows.map((row) => (
                    <Box
                        key={row[0].size}
                        sx={{
                            display: "flex",
                            gap: 1,
                            mb: 1,
                        }}
                    >
                        {row.map((level) => (
                            <Box
                                key={level.size}
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                    minHeight: 88,
                                    borderRadius: "12px",
                                    bgcolor: level.bg,
                                    px: 0.75,
                                    py: 1.25,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                }}
                            >
                                <Box component="span" sx={{ fontSize: 18, lineHeight: 1, mb: 0.5 }} aria-hidden>
                                    {level.emoji}
                                </Box>
                                <Typography sx={{ color: "#fff", fontSize: 13, fontWeight: 800, lineHeight: 1.2 }}>
                                    {level.name}
                                </Typography>
                                <Typography sx={{ color: "#fff", fontSize: 15, fontWeight: 800, mt: 0.5, textAlign: "center" }}>
                                    {level.pieces} pieces
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                ))}
                <Typography
                    component="p"
                    sx={{
                        m: 0,
                        minHeight: 44,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        fontWeight: 700,
                        color: androidLightTokens.shellTextMuted,
                    }}
                >
                    Cancel
                </Typography>
            </Box>
        </Box>
    );
}
